export * from './components/FolderCover/index';
